import { NumberFormatOptions } from 'next-intl';
import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../constants/price';
import Decimal from 'decimal.js';

const instantiateNumberFormat = (
  locale: string = DEFAULT_LOCALE,
  config: NumberFormatOptions = {},
): NumberFormat => {
  const { useGrouping, ...rest } = config;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: DEFAULT_CURRENCY,
    ...((rest ?? {}) as Intl.NumberFormatOptions),
    useGrouping: typeof useGrouping === 'boolean' ? useGrouping : undefined,
  });
};

type NumberFormat = Intl.NumberFormat;

export const convertCentsToUnit = (amount: number): number => {
  const decimalAmount: Decimal = new Decimal(amount);
  const centsDecimalAmount: Decimal = decimalAmount.dividedBy(100);

  return centsDecimalAmount.toNumber();
};

export const format = (
  number: number,
  config?: { locale?: string } & NumberFormatOptions,
): string => {
  const locale = config?.locale ?? DEFAULT_LOCALE;

  return instantiateNumberFormat(locale, config).format(number);
};

export const formatPriceAmount = (
  number: number,
  config?: { locale?: string },
): string =>
  format(number, {
    ...config,
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatPricePossibleFree = (
  number: number,
  label: string,
): string => {
  if (number === 0) {
    return label;
  }

  return format(number);
};

export const getDiscountPrice = (price: number, coupon: any): number => {
  return coupon.amountOff
    ? price - convertCentsToUnit(coupon.amountOff)
    : price * (1 - coupon.percentOff / 100);
};
